/**
 * ConfirmBar - 確定ボタンバー
 * PoC frontend/src/section-classifier/components/ConfirmBar.tsx から移植 + isSubmitting 対応
 */

import { Spinner } from '@/components/Spinner';

interface ConfirmBarProps {
  assignedCount: number;
  totalSections: number;
  onConfirm: () => void;
  onReset: () => void;
  isSubmitting?: boolean;
}

export function ConfirmBar({
  assignedCount,
  totalSections,
  onConfirm,
  onReset,
  isSubmitting = false,
}: ConfirmBarProps) {
  const canConfirm = assignedCount >= 1 && !isSubmitting;

  return (
    <div className="bg-white border-t border-gray-200 px-6 py-3 flex items-center justify-between">
      <div className="text-sm text-gray-600">
        <span>
          設定済み: <span className="font-medium">{assignedCount}</span> / {totalSections} セクション
        </span>
      </div>
      <div className="flex gap-3 items-center">
        <button
          type="button"
          onClick={onReset}
          disabled={isSubmitting}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50"
        >
          リセット
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={`px-6 py-2 text-sm font-medium text-white rounded-md transition-colors flex items-center gap-2 ${
            canConfirm ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300 cursor-not-allowed'
          }`}
          disabled={!canConfirm}
        >
          {isSubmitting && <Spinner size="sm" />}
          {isSubmitting ? '送信中...' : '確定して評価へ進む'}
        </button>
      </div>
    </div>
  );
}
